import { Button, FormatText, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import { getFechamentoCurvaEconomicaByFechamentoId } from '@app/api/fechamento';
import { ReportCicloOrcamentario } from '@app/api/relatorios';
import GraficoCurva from '../GraficoCurva';
const { Panel } = Collapse;


interface FechamentoCurvaEconomicaProps {
    fechamentoId: string;
}


const FechamentoCurvaEconomica = (props: FechamentoCurvaEconomicaProps) => {
    const { fechamentoId } = props;
    const [relatorio, setRelatorio] = useState<ReportCicloOrcamentario>();

    useEffect(() => {
        getFechamentoCurvaEconomicaByFechamentoId(fechamentoId).then((data) => {
            setRelatorio(data);
        });
    }, [fechamentoId]);

    return (

        <GridView noform>
            <Widget
                title="RESULTADO"
                span={12}
                actions={[]}>

                {relatorio ? <GraficoCurva relatorio={relatorio} carregarTabela={true} /> : <> </>}
            </Widget>
        </GridView>

    );

}

export default FechamentoCurvaEconomica;